import _ from 'underscore';
import vars from '@exovera/narrative-tracker-variables';

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

// Checks an array of objects against an object, and adds it if it in not in the array, or removes it if it is.
//    The objects must have a unique field 'id'
//    Does this without mutation
var addOrRemove = function addOrRemove(array, object) {
	var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";

	var isActiveIndex = _.findIndex(array, function (existingObject) {
		return existingObject[id] === object[id];
	});
	var value = void 0;
	if (isActiveIndex < 0) {
		// concat state to avoid mutation (instead of push)
		value = [].concat(toConsumableArray(array), [object]);
	} else {
		// Slice and concat to avoid mutation
		value = array.slice(0, isActiveIndex).concat(array.slice(isActiveIndex + 1));
	}
	return value;
};

// Checks an array of strings against a string, and adds it if it in not in the array, or removes it if it is.
//    Does this without mutation
var addOrRemoveString = function addOrRemoveString(array, string) {
	var isActiveIndex = _.findIndex(array, function (existingString) {
		return existingString === string;
	});
	var value = void 0;
	if (isActiveIndex < 0) {
		// add
		// concat state to avoid mutation (instead of push)
		value = [].concat(toConsumableArray(array), [string]);
	} else {
		// remove
		// Slice and concat to avoid mutation
		value = array.slice(0, isActiveIndex).concat(array.slice(isActiveIndex + 1));
	}
	return value;
};

// compares an array of objects by id, and returns a boolean
var areArraysEqual = function areArraysEqual(arr1, arr2) {
	var areTheyEqual = true;
	if (!arr1 && !arr2) {
		areTheyEqual = true;
	} else if (!_.isArray(arr1) || !_.isArray(arr2)) {
		// What if one isn't an array?
		// true if neither is an array
		if (!_.isArray(arr1) && !_.isArray(arr2)) {
			areTheyEqual = true;
		} else {
			areTheyEqual = false; // if only one isn't an array
		}
	} else if (arr1.length !== arr2.length) {
		areTheyEqual = false;
	} else {
		_.each(arr1, function (obj) {
			var foundOne = _.find(arr2, function (obj2) {
				return obj2.id === obj.id;
			});
			if (!foundOne) {
				areTheyEqual = false;
			}
		});
	}
	return areTheyEqual;
};

var areArraysEqualDeep = function areArraysEqualDeep(arr1, arr2) {
	var areTheyEqual = true;
	if (arr1.length !== arr2.length) {
		areTheyEqual = false;
	} else {
		_.each(arr1, function (obj, index) {
			if (!_.isEqual(obj, arr2[index])) {
				areTheyEqual = false;
			}
		});
	}
	return areTheyEqual;
};

var clickedEnter = function clickedEnter(event) {
	var keyCode = event.key || event.keyCode;
	return keyCode === "Enter" || keyCode === 13;
};

// Copies an object, minus any fields passed
// Does this recursively on any objects or arrays of objects
// NOTE: works on objects and arrays - but not functions (which are technically objects)
// NOTE: if using this on arrays, withoutArr should contain strings: ["1"] to exclude every second item in an array
// 	withoutArr: array of strings, which are the keys to exclude in the obj
var cloneObjectWithout = function cloneObjectWithout(_ref) {
	var obj = _ref.obj,
	    withoutArr = _ref.withoutArr;

	// return strings, numbers, booleans, or functions
	if (!_.isObject(obj) || _.isFunction(obj)) {
		return obj;
	} else {
		// return arrays as an array
		var result = _.isArray(obj) ? [] : {};
		var keys = Object.keys(obj);
		_.each(keys, function (key) {
			if (!_.contains(withoutArr, key)) {
				result[key] = cloneObjectWithout({ obj: obj[key], withoutArr: withoutArr });
			}
		});

		return result;
	}
};

// // Quokka test
// const object = {
// 	foo: 1,
// 	bar: 2,
// 	bas: "stuff",
// };
// const nested = {
// 	foo: 1,
// 	bar: 2,
// 	bas: "stuff",
// 	children: [
// 		{
// 			foo: 1,
// 			bar: 2,
// 			bas: "stuff",
// 		},
// 		{
// 			foo: 1,
// 			bar: 2,
// 			bas: "blah",
// 		},
// 		{
// 			foo: 1,
// 			bar: 2,
// 			cheese: true,
// 			bas: "nope",
// 		},
// 	]
// };
// const array = [1, 2, "stuff"]

// console.log(cloneObjectWithout({ obj: nested, withoutArr: ["bar", "cheese"] }));

// Converts html entities to text
var decodeText = function decodeText(text) {
	var node = document.createElement("textarea");
	node.innerHTML = text;
	var translatedText = node.value;
	node.remove(node);
	return translatedText;
};

// Returns a flat array of all children. Does not mutate orignal array
var flattenNestedArray = function flattenNestedArray(array, kidName) {
	var childName = kidName || "children";
	var flatArray = [];

	_.each(array, function (obj) {
		flatArray = [obj].concat(toConsumableArray(flatArray));
		if (obj[childName]) {
			flatArray = [].concat(toConsumableArray(flattenNestedArray(obj[childName], childName)), toConsumableArray(flatArray));
		}
	});
	return flatArray;
};

// Returns a string, adjusted for locale and abbreviated if a million or larger
//		number- Number to format, required		
//		currency- boolean (default false). Shows currencySymbol if true
//		currencySymbol- string - symbol to show if currency: true (default "$")
var formatNumber = function formatNumber(_ref) {
	var number = _ref.number,
	    _ref$currency = _ref.currency,
	    currency = _ref$currency === undefined ? false : _ref$currency,
	    _ref$currencySymbol = _ref.currencySymbol,
	    currencySymbol = _ref$currencySymbol === undefined ? "$" : _ref$currencySymbol;

	var mil = 1000000;
	var bil = 1000000000;
	var tril = 1000000000000;

	var numberString = 0;
	if (number && number < mil) {
		numberString = number.toLocaleString();
	} else if (number && number >= mil && number < bil) {
		numberString = Math.round(number / mil * 10) / 10 + "M";
	} else if (number && number >= bil && number < tril) {
		numberString = Math.round(number / bil * 10) / 10 + "B";
	} else if (number && number >= tril) {
		numberString = Math.round(number / tril * 10) / 10 + "T";
	}

	return "" + (currency ? currencySymbol : "") + numberString;
};

// Returns the top & left of the point above and in the center of the target element
//   Handles any node; designed for event.target or event.currentTarget
var formatPosition = function formatPosition(target) {
	var boundingRect = target.getBoundingClientRect();
	var position = {
		top: boundingRect.top,
		left: boundingRect.left + (boundingRect.right - boundingRect.left) / 2 // left + half element width
	};
	return position;
};

// Returns true if the target element has class
// import _ from "underscore";

var hasClass = function hasClass(target, className) {
	return new RegExp("(\\s|^)" + className + "(\\s|$)").test(target.className);
};

var getDateObjectFromUTC = function getDateObjectFromUTC(timestamp) {
	// timestamp must include microseconds
	var estOffset = 0; // 14400000;
	var date = new Date(Number(timestamp) - estOffset);

	var dateObject = {
		year: date.getUTCFullYear(),
		month: date.getUTCMonth(), // 0 indexed
		day: date.getUTCDate(),
		hour: date.getHours(),
		min: date.getMinutes()
	};

	return dateObject;
};

var getLongDateStringFromUTC = function getLongDateStringFromUTC(timestamp, dateLib) {
	// timestamp must include microseconds
	// dateLib is an object with the month names in an array
	var dateObj = getDateObjectFromUTC(timestamp);
	return dateLib.months[dateObj.month] + " " + dateObj.day + ", " + dateObj.year;
};

// returns language code string or "auto"
var langCodeLookup = function langCodeLookup(language) {
	if (!language || !_.isString(language)) {
		return "auto";
	}

	var lang = language.toLowerCase();
	if (lang === "lithuanian") {
		return "lt";
	} else if (lang === "latvian") {
		return "lt";
	} else if (lang === "romanian") {
		return "ro";
	} else if (lang === "russian") {
		return "ru";
	} else if (lang === "estonian") {
		return "et";
	} else if (lang === "spanish") {
		return "es";
	} else if (lang === "arabic") {
		return "ar";
	} else if (lang === "chinese") {
		return "zh-CN";
	} else {
		return "auto";
	}
};

// returns the number of items, including nested field
// array: Array of objects (otherwise what's the point?)
//		if list is an object, or an array of objects, you can recursively count the contents of one field
// childName: String - optional. If included, the count will include the children
var nestedArrayLength = function nestedArrayLength(_ref) {
	var array = _ref.array,
	    childName = _ref.childName;

	var length = _.size(array);

	if (childName) {
		_.each(array, function (obj) {
			length += nestedArrayLength({ array: obj[childName], childName: childName });
		});
	}

	return length;
};

// // NOTE: Quokka.js tests (Cmd + k, q) to init
// const testArr = [
// 	{
// 		id: "economics",
// 		name: "Economics",
// 		parent: "narratives",
// 		children: [
// 			{
// 				id: "economic_subs",
// 				name: "Economic Sub Topics",
// 				parent: "economics",
// 				children: [
// 					{
// 						id: "Ag Commodities",
// 						name: "ag",
// 						parent: "economic_subs",
// 					},
// 					{
// 						id: "Economic Development",
// 						name: "eco",
// 						parent: "economic_subs",
// 					},
// 					{
// 						id: "Poverty",
// 						name: "poverty",
// 						parent: "economic_subs",
// 					},
// 				],
// 			},
// 			{
// 				id: "economic_narratives",
// 				name: "Economic Narratives",
// 				parent: "economics",
// 				children: [
// 					{
// 						id: "Narrative one",
// 						name: "Narrative_one",
// 						parent: "economic_narratives",
// 					},
// 					{
// 						id: "Narrative Two",
// 						name: "Narrative_two",
// 						parent: "economic_narratives",
// 					},
// 					{
// 						id: "Narrative Three",
// 						name: "Narrative_three",
// 						parent: "economic_narratives",
// 					},
// 					{
// 						id: "Narrative Four",
// 						name: "Narrative_four",
// 						parent: "economic_narratives",
// 					},
// 				],
// 			},
// 		],
// 	},
// 	{ id: "new_york_times", name: "New York Times", parent: "narratives" },
// 	{ id: "usa_today", name: "USA Today", parent: "narratives" },
// ];

// const stuff = nestedArrayLength({ array: undefined, childName: "children" });

// console.log(stuff);

// Removes an object from an array with a matching id
// idKey: string - the key to use to match ids. Defaults to "id"

// additionalKey & additionalValue: strings. Must pass both to work
// Will match additionalValue to the field additionalKey (other than 'id') to match the objects. Use when id's are not unique

// Returns array intact if the object isn't found
// Does not mutate the original array
var removeById = function removeById(_ref) {
	var array = _ref.array,
	    id = _ref.id,
	    _ref$idKey = _ref.idKey,
	    idKey = _ref$idKey === undefined ? "id" : _ref$idKey,
	    additionalKey = _ref.additionalKey,
	    additionalValue = _ref.additionalValue;

	var removeIndex = _.findIndex(array, function (obj) {
		return additionalKey ? obj[idKey] === id && obj[additionalKey] === additionalValue : obj[idKey] === id;
	});
	if (removeIndex < 0) {
		return array;
	} else {
		return array.slice(0, removeIndex).concat(array.slice(removeIndex + 1));
	}
};

var removeMd5FromStart = function removeMd5FromStart(_ref) {
	var string = _ref.string;

	var md5length = 36; // 32 + md5_

	return string && _.isString(string) && string.startsWith("md5_") ? string.slice(md5length) : string;
};

// Replaces an object from an array with a matching id
// Adds the object if it is not found
// idKey: string - the key to use to match ids. Defaults to "id"

// Does not mutate the original array
var replaceById = function replaceById(_ref) {
	var array = _ref.array,
	    id = _ref.id,
	    _ref$idKey = _ref.idKey,
	    idKey = _ref$idKey === undefined ? "id" : _ref$idKey,
	    replacementObj = _ref.replacementObj;

	var removeIndex = _.findIndex(array, function (obj) {
		return obj[idKey] === id;
	});
	if (removeIndex >= 0) {
		// remove the old object, if it exists
		return array.slice(0, removeIndex).concat(replacementObj).concat(array.slice(removeIndex + 1));
	} else {
		// Add replacementObj to the end if it wasn't in the array
		return [].concat(toConsumableArray(array), [replacementObj]);
	}
};

// Sets a passed field in all objects within an array to whatever the passed value is
// 	If no key is passed, it will look for "active"
// 	value: Any - usually a boolean. Defaults to false

// Does not mutate the original array
var setAllFieldsTo = function setAllFieldsTo(_ref) {
	var array = _ref.array,
	    key = _ref.key,
	    value = _ref.value;

	var theKey = key || "active";
	var theValue = value === undefined ? false : value;

	var cloneArr = array ? JSON.parse(JSON.stringify(array)) : [];

	_.each(cloneArr, function (obj) {
		obj[theKey] = theValue;
	});

	return cloneArr;
};

// Sets a passed field in an object within an array to whatever the passed value is
// 	If no key is passed, it will look for "active"
//	value: Any - usually a boolean

// additionalKey & additionalValue: strings. Must pass both to work
// Will match additionalValue to the field additionalKey (other than 'id') to match the objects. Use when id's are not unique

// If the object isn't found, it returns the original array
// Does not mutate the original array
var setFieldById = function setFieldById(_ref) {
	var array = _ref.array,
	    id = _ref.id,
	    _ref$idKey = _ref.idKey,
	    idKey = _ref$idKey === undefined ? "id" : _ref$idKey,
	    key = _ref.key,
	    value = _ref.value,
	    additionalKey = _ref.additionalKey,
	    additionalValue = _ref.additionalValue;

	var active = key || "active";
	var cloneArr = array ? JSON.parse(JSON.stringify(array)) : [];

	var objIndex = _.findIndex(cloneArr, function (obj) {
		return additionalKey ? obj[idKey] === id && obj[additionalKey] === additionalValue : obj[idKey] === id;
	});
	if (objIndex >= 0) {
		cloneArr[objIndex][active] = value;
	}
	return cloneArr;
};

// Sets a passed field in an object within an array to whatever the passed value is, and sets the other fields to the negativeValue or 'false'
// 		This is the radio button version of setFieldById
// If no key is passed, it will look for "active"
// value: Any - usually a boolean. Defaults to "true" if undefined
// negativeValue: Any - defaults to "false" if undefined

// additionalKey & additionalValue: strings. Must pass both to work
// Will match additionalValue to the field additionalKey (other than 'id') to match the objects. Use when id's are not unique

// If the object isn't found, it returns the original array
// Does not mutate the original array
var setOneFieldById = function setOneFieldById(_ref) {
	var array = _ref.array,
	    id = _ref.id,
	    key = _ref.key,
	    value = _ref.value,
	    negativeValue = _ref.negativeValue,
	    additionalKey = _ref.additionalKey,
	    additionalValue = _ref.additionalValue;

	var active = key || "active";
	var negValue = negativeValue === undefined ? false : negativeValue;
	var posValue = value === undefined ? true : value;
	var cloneArr = array ? JSON.parse(JSON.stringify(array)) : [];

	var objIndex = _.findIndex(cloneArr, function (obj) {
		return additionalKey ? obj.id === id && obj[additionalKey] === additionalValue : obj.id === id;
	});

	if (objIndex >= 0) {
		_.each(cloneArr, function (obj) {
			obj[active] = negValue;
		});
		cloneArr[objIndex][active] = posValue;
	}
	return cloneArr;
};

// returns target string with remove excised.
//    Intended use case: ('222px', 'px') => '222'. ('px222', 'px') => '222' also works
//    NOTE: If the remove is in the middle, it will only return the first portion of the target.
var stripString = function stripString(target, remove) {
	var value = target;
	value = value.trim().split(remove);
	value = _.reject(value, "");
	return value && value.length > 0 && value[0];
};

// Polyfill for Number.isInteger - return boolean
var isInteger = function isInteger(possibleInteger) {
	return typeof possibleInteger === "number" && Math.floor(possibleInteger) === possibleInteger;
};

// The following works because NaN is the only value in javascript which is not equal to itself.
//	From: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
var isNaN = Number.isNaN || function (value) {
	return typeof value === "number" && value !== value;
};

// Aggregate a time series. It groups working backwards, so the last date is always represented.
//		Any remainder at the beginning is omited, as it's not a full span
// span: number of units to aggregate by
// limit: number - threshhold timeseries length. Returns false otherwise.
//	percentage: boolean - averages each week instead of adding them
// NOTE: does not mutate the original timeseries (builds a new one)
var aggregateTimeseries = function aggregateTimeseries(_ref) {
	var timeseries = _ref.timeseries,
	    span = _ref.span,
	    limit = _ref.limit,
	    percentage = _ref.percentage;

	var theTimeseriesIsTooShort = limit && _.size(timeseries) < limit;

	if (theTimeseriesIsTooShort) {
		return false;
	} else {
		var aggregatedResult = {};
		var reverseAggregation = {};
		var counter = 0;
		var loopCounter = 0;
		var aggregationValue = 0;
		var targetDate = 0;

		var reversedDates = Object.keys(timeseries).reverse();
		for (var i = 0; i < reversedDates.length; i++) {
			// set target date at the beginning of the section
			if (loopCounter === 0) {
				targetDate = reversedDates[i];
			}

			aggregationValue += timeseries[reversedDates[i]];
			counter++;
			loopCounter++;

			if (counter % span === 0) {
				reverseAggregation[targetDate] = aggregationValue;
				aggregationValue = 0;
				loopCounter = 0;
			}
		}
		// flip it back
		var dates = Object.keys(reverseAggregation).reverse();
		for (var _i = 0; _i < dates.length; _i++) {
			aggregatedResult[dates[_i]] = percentage ? Math.round(reverseAggregation[dates[_i]] / span) : reverseAggregation[dates[_i]];
		}

		// // forwards: works, but clips from the end of the timeseries
		// _.each(timeseries, (value, key) => {
		// 	aggregationValue += value;
		// 	counter++;
		// 		if (counter % span === 0) {
		// 			aggregatedResult[key] = aggregationValue;
		// 			aggregationValue = 0;
		// 		}
		// });

		return aggregatedResult;
	}
};

// Returns `rows` with the objects that have a property that matches the string. Only looks in properties whose keys are in `fields`.
var filterRowsByString = function filterRowsByString(_ref) {
	var rows = _ref.rows,
	    fields = _ref.fields,
	    string = _ref.string;

	if (!string) {
		return rows;
	} else {
		var lowString = string.toLowerCase();
		return _.filter(rows, function (row) {
			return _.find(fields, function (field) {
				var lowercaseString = row[field] && typeof row[field] === "string" ? row[field].toLowerCase() : row && row[field] && row[field].toString(); // it's a number, so no lowercase necessary
				return lowercaseString && lowercaseString.includes(lowString);
			});
		});
	}
};

// returns the integer value off all dates within the given zoom
var totalInRange = function totalInRange(timeseries, zoom) {
	if (!timeseries || !zoom || !zoom.begin || !zoom.end) {
		return 0;
	} else {
		var total = 0;
		_.each(timeseries, function (value, key) {
			if (key >= zoom.begin && key <= zoom.end) {
				total += value || 0; // valid falsey fill be 0 anyway
			}
		});
		return total;
	}
};

// trims a timeseries. Will return the start and end objects and everything in between.
// Does not mutate the original.
// Has no effect if the start and end range is larger than the timeseries
//    series: flat object. Keys are expected to be numbers (or number strings) that are in sequence
//    zoom: object {
//   		begin: number - utc stamp
//   		end: number - utc stamp
// 		}
// NOTE: assumes all timeseries dates are set the to beginning of the day
var trimSeries = function trimSeries(_ref) {
	var timeseries = _ref.timeseries,
	    zoom = _ref.zoom;

	if (_.isEmpty(zoom)) {
		return timeseries;
	} else {
		var series = {};
		var zoomBegin = Number(zoom.begin);
		var zoomEnd = Number(zoom.end);
		_.each(timeseries, function (value, key) {
			if (key >= zoomBegin && key <= zoomEnd) {
				series[key] = value;
			}
		});

		return series;
	}
};

// allOR: boolean. Removes all brackets and separates all filters by OR
var abbreviatedFilterText = function abbreviatedFilterText(params) {
	var filtersList = params.filtersList,
	    availableSpace = params.availableSpace,
	    defaultText = params.defaultText,
	    allOR = params.allOR,
	    allAND = params.allAND,
	    _params$keywordsAND = params.keywordsAND,
	    keywordsAND = _params$keywordsAND === undefined ? true : _params$keywordsAND;


	var filtersListClean = _.uniq(filtersList, false, // not sorted
	_.iteratee("id", "parent"));

	if (!filtersListClean || filtersListClean.length <= 0) {
		return defaultText || "Filters";
	} else if (availableSpace < 30) {
		return "Filters";
	} else if (typeof filtersListClean[0] === "string" || filtersListClean[0] instanceof String) {
		var filtersDisplayText = "Filters";
		var possibleStrings = [];
		var trimedFiltersArr = filtersListClean.map(function (str) {
			return removeMd5FromStart({ string: str.trim() });
		});
		// Make an array of possible strings
		for (var index = 0; index < trimedFiltersArr.length; index++) {
			var stringSoFar = trimedFiltersArr.slice(0, index + 1).join(", ");

			var remainingFilters = trimedFiltersArr.length - 1 - index;
			var proposedString = remainingFilters ? stringSoFar + ", + " + remainingFilters + " more" : stringSoFar;
			possibleStrings.push(proposedString);
		}

		// Check those strings against the space
		_.each(possibleStrings, function (filterString) {
			if (filterString.length * 7 < availableSpace) {
				filtersDisplayText = filterString;
			}
		});

		return filtersDisplayText;
	} else {
		var _filtersDisplayText = "Filters";
		if (allOR || allAND) {
			var md5StringsArray = _.pluck(filtersListClean, "name");
			var filterStringsArray = md5StringsArray.map(function (string) {
				return removeMd5FromStart({ string: string });
			});
			var _remainingFilters = filterStringsArray.length;

			// Start with smallest possible string
			var _possibleStrings = [filterStringsArray[0].trim() + ", + " + (filterStringsArray.length - 1) + " more"];

			// Make an array of possible strings
			var _stringSoFar = "";
			for (var _index = 0; _index < filterStringsArray.length; _index++) {
				var filter = filterStringsArray[_index];
				// no AND on the first loop
				_stringSoFar = _stringSoFar ? _stringSoFar + " " + (allOR ? "OR" : "AND") + " " + filter : filter;

				_remainingFilters--;
				var _proposedString = _remainingFilters ? _stringSoFar + ", + " + _remainingFilters + " more" : _stringSoFar;
				_possibleStrings.push(_proposedString);
			}

			// Check those strings against the space
			_.each(_possibleStrings, function (filterString) {
				if (filterString.length * 7 < availableSpace) {
					_filtersDisplayText = filterString;
				}
			});
		} else {
			var orClusters = [];
			var filterTypeGroups = _.groupBy(filtersListClean, "parent"); // returns an object

			// convert each group into text
			_.each(filterTypeGroups, function (filters) {
				var theseAreKeywords = filters[0].parent === "keywords";

				// Make an array of the filter names
				var groupFilterNamesArr = filters.map(function (filter) {
					return removeMd5FromStart({ string: filter.name.trim() });
				});

				if (theseAreKeywords && keywordsAND) {
					var groupFilterNames = groupFilterNamesArr.join(" AND ");
					orClusters.push({
						text: groupFilterNames,
						number: filters.length
					});
				} else {
					// convert the filter names into a string
					var _groupFilterNames = groupFilterNamesArr.join(" OR ");
					var wrappedString = filters.length > 1 ? "(" + _groupFilterNames + ")" : _groupFilterNames;
					orClusters.push({
						text: wrappedString,
						number: filters.length
					});
				}
			});

			var _stringSoFar2 = "";
			// Add up total number of filters
			var _remainingFilters2 = 0;
			_.each(orClusters, function (obj) {
				_remainingFilters2 += obj.number;
			});

			// Start with smallest possible string
			var _possibleStrings2 = [filtersListClean[0].name.trim() + ", + " + (_remainingFilters2 - 1) + " more"];

			// Make an array of possible strings
			for (var _index2 = 0; _index2 < orClusters.length; _index2++) {
				var cluster = orClusters[_index2];
				// no AND on the first loop
				_stringSoFar2 = _stringSoFar2 ? _stringSoFar2 + " AND " + cluster.text : cluster.text;

				_remainingFilters2 -= cluster.number;
				var _proposedString2 = _remainingFilters2 ? _stringSoFar2 + ", + " + _remainingFilters2 + " more" : _stringSoFar2;
				_possibleStrings2.push(_proposedString2);
			}

			// Check those strings against the space
			_.each(_possibleStrings2, function (filterString) {
				if (filterString.length * 7 < availableSpace) {
					_filtersDisplayText = filterString;
				}
			});
		}

		return _filtersDisplayText;
	}
};

// Formats entityFilters (which is a list of differently shaped objects) and merges them with activeFilters
// NOTE: activeFilters sometimes contains entities & vice versa. This cleans them out
// NOTE: injects keywords too, which is an array of filter objects.
var mergeEntityFilters = function mergeEntityFilters(_ref) {
	var activeFilters = _ref.activeFilters,
	    entityFilters = _ref.entityFilters,
	    keywords = _ref.keywords,
	    perspective = _ref.perspective;

	var activeFiltersArr = activeFilters ? _.reject(activeFilters, function (filter) {
		return filter.parent === "entities" || filter.parent === "keywords";
	}) : [];
	var entityFiltersArr = entityFilters && perspective === "Source" ? _.reject(entityFilters, function (filter) {
		return !filter.type; // only entities have 'type'
	}) : [];

	var formattedEntityFilters = [];
	if (entityFiltersArr) {
		_.each(entityFiltersArr, function (entity) {
			formattedEntityFilters.push({
				id: entity.name,
				name: entity.name,
				parent: "entities",
				active: true,
				type: entity.type
			});
		});
	}

	var uniqueFilters = _.uniq([].concat(toConsumableArray(activeFiltersArr), formattedEntityFilters), false, _.iteratee("id", "name"));

	return keywords && perspective === "Source" ? [].concat(toConsumableArray(uniqueFilters), toConsumableArray(keywords)) : uniqueFilters;
};

// Returns an array of clones of each active filter
var pluckActiveFilters = function pluckActiveFilters(filters) {
	var activeFilters = [];
	_.each(filters, function (filter) {
		// Push top level active filters
		if (filter.active) {
			activeFilters.push({
				active: true,
				color: filter.color ? JSON.parse(JSON.stringify(filter.color)) : undefined,
				filterType: filter.filterType,
				grandparent: filter.grandparent,
				id: filter.id,
				icon: filter.icon,
				label: filter.label,
				name: filter.name,
				parent: filter.parent,
				type: filter.type
			});
		}
		// Push child filters
		if (filter.children) {
			_.each(filter.children, function (childFilter) {
				if (childFilter.active) {
					activeFilters.push({
						active: true,
						color: childFilter.color ? JSON.parse(JSON.stringify(childFilter.color)) : undefined,
						filterType: childFilter.filterType,
						grandparent: childFilter.grandparent,
						id: childFilter.id,
						icon: childFilter.icon,
						label: childFilter.label,
						name: childFilter.name,
						parent: childFilter.parent,
						type: childFilter.type
					});
				}
				if (childFilter.children) {
					_.each(childFilter.children, function (grandchildFilter) {
						if (grandchildFilter.active) {
							activeFilters.push({
								active: true,
								color: childFilter.color ? JSON.parse(JSON.stringify(childFilter.color)) : undefined,
								filterType: grandchildFilter.filterType,
								grandparent: grandchildFilter.grandparent,
								id: grandchildFilter.id,
								icon: grandchildFilter.icon,
								label: grandchildFilter.label,
								name: grandchildFilter.name,
								parent: grandchildFilter.parent,
								type: grandchildFilter.type
							});
						}
					});
				}
			});
		}
	});

	return activeFilters;
};

// clone the filters manually - JSON.parse can't handle the function in icon
var cloneFilters = function cloneFilters(array) {
	var filters = [];

	_.each(array, function (obj) {
		var filter = JSON.parse(JSON.stringify(obj));
		filter.icon = obj.icon; // function
		if (obj.children) {
			filter.children = cloneFilters(obj.children);
		}
		filters.push(filter);
	});

	return filters;
};

// Clone filters and toggles the active or open state, depending on whether the
//    element has children (only the final children are filters)
var toggleClickedFilter = function toggleClickedFilter(_ref) {
	var array = _ref.array,
	    filter = _ref.filter,
	    id = _ref.id,
	    narrative = _ref.narrative,
	    caret = _ref.caret;

	// console.log("toggleClickedFilter ====>", params);

	var filters = cloneFilters(array);
	var targetFilter = void 0;
	var parentFilter = void 0;
	var topId = filter.grandparent ? filter.grandparent : filter.parent;

	// Find the right top filter
	var topFilter = _.find(filters, function (obj) {
		return obj.id === topId;
	});

	// Find the target filter - dig into filter's parent if it has a grandparent
	if (filter.grandparent) {
		parentFilter = _.find(topFilter.children, function (obj) {
			return obj.id === filter.parent;
		});

		targetFilter = parentFilter && _.find(parentFilter.children, function (obj) {
			return obj.id === id;
		});
	} else {
		// find parent filter
		targetFilter = _.find(topFilter.children, function (obj) {
			return obj.id === id;
		});
	}

	// If there are children, set open, otherwise set active
	if (targetFilter) {
		if (filter.children) {
			targetFilter.open = !filter.open;

			// if it's a narrative, set it's active state'
			if (narrative) {
				targetFilter.active = !filter.active;
				// Always keep parent narratives open when they're clicked (must close with caret click)
				targetFilter.open = true;
				// deactivate all children whenever the parent is changed
				_.each(targetFilter.children, function (child) {
					child.active = false;
				});
			}
			// if it's a narrative and the parent is active, deactivate parent
		} else if (narrative && parentFilter && parentFilter.active) {
			parentFilter.active = false;
			targetFilter.active = true;
		} else if (!caret) {
			targetFilter.active = !filter.active;
		}
	}

	return filters;
};

// returns a hex color, when color is a string or object
// defaults to sky_2
var findColor = function findColor(params) {
	var color = params.color,
	    colorKey = params.colorKey;

	if (_.isString(color)) {
		return color;
	} else if (colorKey && _.isObject(color) && color[colorKey]) {
		return color[colorKey];
	} else {
		return vars.sky_2;
	}
};

var getColorScore = function getColorScore(hexString) {
	var r = parseInt(hexString.substr(1, 2), 16);
	var g = parseInt(hexString.substr(3, 2), 16);
	var b = parseInt(hexString.substr(4, 2), 16);

	return Math.sqrt(0.241 * Math.pow(r, 2) + 0.691 * Math.pow(g, 2) + 0.068 * Math.pow(b, 2));
};

// Returns the string with the most contrast with the background
//		Accepts a hex string with hash: "#00bff3"
// 		Strings must be full 6 character
var higherContrast = function higherContrast(params) {
	var color1 = params.color1,
	    color2 = params.color2,
	    background = params.background;

	if (!color1 || !color2 || !background) {
		console.error("higherContrast() requires three hex strings. Received: ", color1, color2, background);
	}
	if (color1.length !== 7 || color2.length !== 7 || background.length !== 7) {
		console.error("higherContrast() requires full length hex strings: e.g., '#00bff3'.", color1, color2, background);
	}
	var text1Score = getColorScore(color1);
	var text2Score = getColorScore(color2);
	var backgroundScore = getColorScore(background);

	return Math.abs(text1Score - backgroundScore) > Math.abs(text2Score - backgroundScore) ? color1 : color2;
};

// Returns a true if there is enough contrast between text and background. Colorable's AA Large fails, but AA passes
//		Accepts a hex string with hash: "#00bff3"
// 		Strings must be full 6 character
var isThisEnoughContrast = function isThisEnoughContrast(text, background) {
	if (!text || !background) {
		console.error("isThisEnoughContrast() requires two hex strings. Received: ", text, background);
	}
	if (text.length !== 7 || background.length !== 7) {
		console.error("isThisEnoughContrast() requires full length hex strings: e.g., '#00bff3'.", text, background);
	}
	var textScore = getColorScore(text);
	var backgroundScore = getColorScore(background);

	return Math.abs(textScore - backgroundScore) > 75;
};

// General

// Icons
// export { default as pickIcon } from "./icons/pickIcon.js";

export { addOrRemove, addOrRemoveString, areArraysEqual, areArraysEqualDeep, clickedEnter, cloneObjectWithout, decodeText, flattenNestedArray, formatNumber, formatPosition, hasClass, getDateObjectFromUTC, getLongDateStringFromUTC, langCodeLookup, nestedArrayLength, removeById, removeMd5FromStart, replaceById, setAllFieldsTo, setFieldById, setOneFieldById, stripString, isInteger, isNaN, aggregateTimeseries, filterRowsByString, totalInRange, trimSeries, abbreviatedFilterText, mergeEntityFilters, pluckActiveFilters, toggleClickedFilter, findColor, getColorScore, higherContrast, isThisEnoughContrast };
//# sourceMappingURL=index.es.js.map
